// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const processStepsSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  processId: z.string().max(100),
  templateId: z.string().max(100).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  stepType: z.string().max(200),
  order: z.number().int().min(0).max(999999),
  optional: z.boolean(),
  enabled: z.boolean(),
  nextStepId: z.string().max(100).optional(),
  action: z.record(z.string(), z.unknown()).optional(),
  conditions: z.array(z.record(z.string(), z.unknown())).optional(),
  outputs: z.array(z.record(z.string(), z.unknown())).optional(),
  outputExtraction: z.record(z.string(), z.unknown()).optional(),
  inputs: z.record(z.string(), z.unknown()).optional(),
  requiredVariables: z.array(z.string()).optional(),
  position: z.record(z.string(), z.unknown()).optional(),
  estimatedDurationMinutes: z.number().int().optional(),
  icon: z.string().max(50).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type ProcessStepsInput = z.infer<typeof processStepsSchema>
